import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { getSpacing } from "@faire/web/slate/spacing";
import {
  Span,
  Typography,
  TypographyVariants,
} from "@faire/web/slate/Typography";
import React from "react";

export const StatusBadge: React.FC<{
  statusBadge: IInformationMessage;
  typographyVariant?: TypographyVariants;
}> = ({ statusBadge, typographyVariant }) => {
  return (
    <Typography>
      <Span
        className="inline-block content-center rounded-sm text-nowrap"
        style={{
          backgroundColor: statusBadge.background_color,
          padding: getSpacing("1/2x", "1x"),
        }}
        color={statusBadge.text_color}
        variant={
          typographyVariant
            ? typographyVariant
            : {
                mobileAndAbove: "labelSansRegular",
                desktopAndAbove: "paragraphSansRegular",
              }
        }
      >
        {statusBadge.text}
      </Span>
    </Typography>
  );
};
